import React from "react";

const Footer = () => {
  return (
    <div id="footer" style={{ backgroundColor: "#242424", padding: "20px", width: "100%" }}>
      <div id="legal" style={{ color: "#949494" }}>
        <h4 style={{ color: "#00adda" }}>Terms of Use and Privacy Statement</h4>
        <p>
          <a
            href="http://www.cbe.ab.ca/privacy-statement"
            title="Privacy Statement"
            target="_blank"
            rel="noopener noreferrer"
            className="privacy"
            style={{ color: "white" }}
          >
            CBE Privacy Statement
          </a>
        </p>
        <p className="cbe-text-muted">
          Personal information is collected under the authority of section 4 of Alberta's{" "}
          <i>Protection of Privacy Act</i> (POPA) and, if applicable, the{" "}
          <i>Education Act</i>, and the Student Record Regulation. This information will be
          used to support educational programming, student records management, and
          administrative operations. Personal information may be entered into automated
          systems for processing and management purposes. It will be treated in accordance
          with POPA. If you have any questions about the collection of personal information,
          contact the{" "}
          <a href="mailto:ATIP@cbe.ab.ca" style={{ color: "white" }}>
            Access to Information and Privacy (ATIP) coordinator
          </a>
          , or 403-817-7899.
        </p>
        <p className="cbe-text-muted">
          © {new Date().getFullYear()} Calgary Board of Education. All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default Footer;
